import "../styles/components/introduction.scss";
import { useTranslation, Trans } from "react-i18next";

export default function Introduction() {
  const { t } = useTranslation();
  return (
    <div className="introduction spacing-block">
      <div className="top-content">
        {/* <h2 className="text-8xl">Hello 👋</h2> */}
        <h2 className="text-8xl">{t("introduction.hello")}</h2>
        <p className="text-4xl">
          <Trans i18nKey="introduction.text_1">
            Ben<s>jamin</s>,<b>Creative & Strategic Director</b> based in
            France.
          </Trans>
        </p>
        {/* <p className="text-4xl">
          I'm a French <b>Digital Designer</b> based in Nantes.
        </p> */}
        <p className="text-4xl">
          <Trans i18nKey="introduction.text_2">
            Focused on <b>design</b> (advertising, product, and web),{" "}
            <b>marketing</b>, and
            <b>web-development</b>, I also integrate an <b>analytical</b> and{" "}
            <b>strategic</b>
            dimension into my approach. This complementarity allows me to step
            back, align <b>creativity</b> with <b>performance</b>, and maintain
            a <b>comprehensive and coherent understanding</b> of projects.
          </Trans>
        </p>
      </div>
      <div className="bottom-content">
        {/* <div className="ornaments text-8xl">ImOpenToWork</div> */}
        <div className="text text-3xl">
          <Trans i18nKey="introduction.text_3">
            Passionate about innovation, I strive to offer{" "}
            <b>
              creative and strategic ideas that combine aesthetics and
              performance
            </b>{" "}
            for each project. My goal is to{" "}
            <b>
              push the boundaries of design while addressing the unique
              challenges of each client.
            </b>
            .
          </Trans>
        </div>
      </div>
    </div>
  );
}
